import React from "react";
import verified from "../../assets/verified.svg";

const ConfirmedViewChart = ({ viewtype, onClose }) => {
  return (
    <div className="fixed inset-0 z-50 bg-black bg-opacity-80 w-screen h-screen flex justify-center items-center font-inter">
      <div className="bg-white rounded-[10px] px-[75px] flex flex-col justify-center items-center gap-4 py-[45px]">
        <img src={verified} alt="" className="" />
        <p className="font-[550] max-w-[250px] text-center leading-5 pt-1">{`Please add KPIs to the "${viewtype}" Chart`}</p>
        <button
          className="bg-[#55C880] px-5 py-3 rounded-[10px] text-white"
          onClick={() => onClose(viewtype)}
        >
          Ok
        </button>
      </div>
    </div>
  );
};

export default ConfirmedViewChart;
